function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H30V30H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.355.7H10.106l-.023-.06A1.023 1.023 0 0 0 9.128 0H4.442a1.606 1.606 0 0 0-1.634 1.568v16.863A1.607 1.607 0 0 0 4.442 20h12.187a.584.584 0 0 0 .478-.247.567.567 0 0 0 .065-.527h4.183a1.444 1.444 0 0 0 1.452-1.461V2.171A1.449 1.449 0 0 0 21.355.7zm-.192 16.831h-4.626l-.724-1.885a.824.824 0 0 0-.157-1.637h-.474l-.592-1.549h4.544a.845.845 0 1 0 0-1.69h-5.178l-.592-1.55h5.771a.811.811 0 1 0 0-1.621h-6.406l-.592-1.548h7a.845.845 0 1 0 0-1.69H11.5L10.74 2.4h10.423v15.14z",
  transform: "translate(2.192 5)"
});

function SvgIconCases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCases);
export default __webpack_public_path__ + "static/media/iconCases.80c26ad7.svg";
export { ForwardRef as ReactComponent };